<template>
  <div>
    <el-card shadow="always" :body-style="{ padding: '20px' }">
      <!-- <div
        class="container"
        v-if="
          ledgerBiTotal.hasOwnProperty('totalBtc') &&
            ledgerBiTotal.hasOwnProperty('avgExchangeRate')
        "
      > -->
      <transition-group tag="div" class="container" name="el-zoom-in-top">
        <DashboardBiTotalElement key="newBiTotal"></DashboardBiTotalElement>
        <DashboardBiTodayElement key="newBiToday"></DashboardBiTodayElement>
        <DashboardBiTotalInRubElement key="newBiTotalInRub"></DashboardBiTotalInRubElement>
        <DashboardValuteExchangeRateToRub
          bckey="BTC"
          key="ExRateToRub"
        ></DashboardValuteExchangeRateToRub>
        <!-- <DashboardValuteOurRateToValute
          bckeyFrom="BTC"
          bckeyTo="QWRUB"
          key="ExRateToValute"
        ></DashboardValuteOurRateToValute> -->
      </transition-group>
      <!-- </div> -->
    </el-card>
    <el-card
      shadow="always"
      :body-style="{ padding: '20px' }"
      v-loading="ledgerDashboardsLoading || !balancesLoaded"
    >
      <!-- <div slot="header">
      <span>Балансы</span>
    </div> -->
      <div
        class="reorder-controls"
        v-if="dashboardElements.docs && dashboardElements.docs.length"
      >
        <div class="reorder-controls__left">
          <el-button v-if="!isReordering" size="small" @click="startReordering"
            >Изменить порядок</el-button
          >
          <template v-else>
            <el-button
              size="small"
              type="primary"
              :loading="reorderSaving"
              @click="saveReordering"
              >Сохранить</el-button
            >
            <el-button size="small" :disabled="reorderSaving" @click="cancelReordering"
              >Отмена</el-button
            >
          </template>
        </div>
        <div
          class="reorder-controls__right"
          @mouseover="balancesRefreshHovered = true"
          @mouseleave="balancesRefreshHovered = false"
        >
          <el-tooltip
            v-if="balancesLoadError"
            content="Не удалось обновить балансы, показаны последние известные значения"
            placement="top"
          >
            <i class="el-icon-warning balances-error-icon"></i>
          </el-tooltip>
          <el-button
            v-show="balancesRefreshHovered"
            :loading="balancesRefreshing"
            type="primary"
            icon="el-icon-refresh"
            circle
            size="mini"
            @click="forceRefreshBalances"
          ></el-button>
          <el-progress
            v-show="!balancesRefreshHovered"
            :percentage="balancesPercentageRemained"
            type="circle"
            :width="28"
            :stroke-width="2"
            :format="pers => ``"
          ></el-progress>
        </div>
      </div>
      <!-- <div class="container" v-if="dashboardElements.docs"> -->
      <template v-if="dashboardElements.docs && balancesLoaded">
        <draggable
          v-if="isReordering"
          v-model="reorderedElements"
          tag="div"
          class="container"
          ghost-class="dragging-ghost"
        >
          <div
            v-for="element in reorderedElements"
            :key="element._id"
            class="reorder-item"
          >
            <DashboardBalanceElement
              :balanceElement="element"
              :balanceData="balances[element.balanceAccount]"
              :refreshing="balancesRefreshing"
              @deleted="fetchBalances"
            >
            </DashboardBalanceElement>
            <div class="reorder-overlay"></div>
          </div>
        </draggable>
        <transition-group
          v-else
          tag="div"
          class="container"
          name="el-zoom-in-top"
        >
          <DashboardBalanceElement
            v-for="element in dashboardElements.docs"
            :key="element._id"
            :balanceElement="element"
            :balanceData="balances[element.balanceAccount]"
            :refreshing="balancesRefreshing"
            @deleted="fetchBalances"
          >
          </DashboardBalanceElement>
        </transition-group>
      </template>
      <!-- </div> -->
      <el-collapse v-if="!isReordering">
        <el-collapse-item name="1">
          <template slot="title">
            <i class="header-icon el-icon-plus"></i>
            Добавить элемент
          </template>
          <div v-if="balanceAccounts.length">
            <el-form
              ref="addBalanceAccountForm"
              label-width="80px"
              :inline="false"
              size="normal"
            >
              <el-form-item label="Баланс">
                <el-select
                  v-model="newBalanceAccount"
                  filterable
                  clearable
                  :loading="!balanceAccounts.length"
                >
                  <el-option
                    v-for="item in balanceAccountsOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-button type="primary" @click="handleAddDashboardElement"
                  >Добавить</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-item>
      </el-collapse>
      <p v-else class="reorder-hint">
        Добавление виджетов недоступно во время изменения порядка.
      </p>
    </el-card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import draggable from "vuedraggable";
import { getBalanceAccounts } from "@/api";
import DashboardBalanceElement from "./Dashboard/balance.vue";
import DashboardBiTotalElement from "./Dashboard/ledgerBiTotal.vue";
import DashboardBiTodayElement from "./Dashboard/ledgerBiToday.vue";
import DashboardBiTotalInRubElement from "./Dashboard/ledgerBiTotalInRub.vue";
import DashboardValuteExchangeRateToRub from "./Dashboard/valuteExchangeRateToRub.vue";
import DashboardValuteOurRateToValute from "./Dashboard/valuteOurRateToValute.vue";
export default {
  name: "LedgerDashboardComponent",
  components: {
    draggable,
    DashboardBalanceElement,
    DashboardBiTotalElement,
    DashboardBiTodayElement,
    DashboardBiTotalInRubElement,
    DashboardValuteExchangeRateToRub,
    DashboardValuteOurRateToValute
  },
  data: () => ({
    balanceAccounts: [],
    newBalanceAccount: null,
    isReordering: false,
    reorderedElements: [],
    reorderSaving: false,
    balances: {},
    balancesLoaded: false,
    balancesLoadError: false,
    balancesRefreshing: false,
    balancesRefreshHovered: false,
    balancesRefreshRate: 5 * 60 * 1000,
    balancesRemainedTime: 0,
    balancesInterval: null,
    balancesRemainedInterval: null
  }),
  computed: {
    ...mapState("ledgerDashboards", {
      dashboardElements: state => state.dashboardElements,
      ledgerDashboardsLoading: state => state.loading
    }),
    balanceAccountsOptions() {
      return this.balanceAccounts
        .map(ba => {
          return {
            value: ba._id,
            label: ba.title
          };
        })
        .filter(ba => {
          if (!this.dashboardElements.docs) return true;
          return !this.dashboardElements.docs
            .map(de => de.balanceAccount)
            .includes(ba.value);
        });
    },
    balancesPercentageRemained() {
      return (this.balancesRemainedTime * 100) / this.balancesRefreshRate < 0
        ? 0
        : (this.balancesRemainedTime * 100) / this.balancesRefreshRate;
    }
  },
  methods: {
    ...mapActions("ledgerDashboards", [
      "getDashboardElements",
      "addDashboardElement",
      "deleteDashboardElement",
      "reorderDashboardElements"
    ]),
    startReordering() {
      this.reorderedElements = [...(this.dashboardElements.docs || [])];
      this.isReordering = true;
    },
    cancelReordering() {
      this.isReordering = false;
      this.reorderedElements = [];
    },
    async saveReordering() {
      this.reorderSaving = true;
      try {
        await this.reorderDashboardElements(
          this.reorderedElements.map(element => element._id)
        );
        this.isReordering = false;
        this.reorderedElements = [];
        return this.$notify.success({
          title: "Успех",
          message: "Порядок сохранён!"
        });
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.reorderSaving = false;
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isNew) {
        return "new-row";
      }
      return "";
    },
    async handleAddDashboardElement() {
      if (!this.newBalanceAccount) return;
      try {
        const resp = await this.addDashboardElement({
          balanceAccount: this.newBalanceAccount
        });
        this.newBalanceAccount = null;
        await this.fetchBalances();
        return this.$notify.success({
          title: "Успех",
          message: `Новый элемент добавлен!`
        });
      } catch (error) {
        this.handleResponseError(error);
      }
    },
    async fetchBalances() {
      if (this.balancesInterval) clearTimeout(this.balancesInterval);
      this.balancesRefreshing = true;
      this.balancesRemainedTime = this.balancesRefreshRate;
      try {
        const ids = (this.dashboardElements.docs || []).map(
          el => el.balanceAccount
        );
        if (ids.length) {
          const { data } = await getBalanceAccounts({
            pagination: false,
            query: { _id: { $in: ids } }
          });
          if (!data.status) throw new Error("Не удалось получить балансы");
          this.balances = data.result.docs.reduce((acc, doc) => {
            acc[doc._id] = doc;
            return acc;
          }, {});
        } else {
          this.balances = {};
        }
        this.balancesLoadError = false;
      } catch (error) {
        this.balancesLoadError = true;
      } finally {
        this.balancesLoaded = true;
        this.balancesRefreshing = false;
        this.balancesInterval = setTimeout(
          this.fetchBalances,
          this.balancesRefreshRate
        );
      }
    },
    async forceRefreshBalances() {
      await this.fetchBalances();
    }
  },
  async mounted() {
    // if (!this.valutes.length) await this.getSortedValutes();
    try {
      const balanceAccountsResp = await getBalanceAccounts({
        pagination: false
      });
      if (balanceAccountsResp.data.status)
        this.balanceAccounts = balanceAccountsResp.data.result.docs;
    } catch (error) {
      this.handleResponseError(error);
    }
    try {
      await this.getDashboardElements();
    } catch (error) {
      this.handleResponseError(error);
    }
    await this.fetchBalances();
    this.balancesRemainedInterval = setInterval(() => {
      this.balancesRemainedTime -= 1000;
    }, 1000);
  },
  beforeDestroy() {
    clearTimeout(this.balancesInterval);
    clearInterval(this.balancesRemainedInterval);
  }
};
</script>
<style scoped>
.container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.reorder-controls {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.reorder-controls__right {
  display: flex;
  align-items: center;
  gap: 6px;
}
.balances-error-icon {
  color: #f56c6c;
  font-size: 16px;
}
.reorder-hint {
  color: #909399;
  font-size: 13px;
  margin: 10px 0 0;
}
.reorder-item {
  position: relative;
}
.reorder-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  cursor: move;
}
.container >>> .dragging-ghost {
  opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/Balances/dashboard.vue